<template>
  <footer class="navbar-footer">
    <div class="fast-overall">
      <div class="fast-link">
        <ul>
          <li><router-link to="/introduction" class="link-home">关于NQI综合服务信息系统</router-link></li>
          <li>（平台背景，平台使命）</li>
        </ul>
      </div>
      <div class="fast-link">
        <ul>
          <li class="link-home">联系我们</li>
          <li>技术支持电话：0571-88221791</li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'bottomFooter',
  data () {
    return {
    }
  },
  created () {
  },
  computed: {
  },
  watch: {
  }
}
</script>

<style lang="less" scoped>
  .navbar-footer {
    background-color: #2E5C9A;
    color: #333333;
    height: 256px;
    width: 100%;
    padding-top: 41px;
    box-sizing: border-box;
    .fast-overall{
      width: @body-width;
      margin: 0 auto;
      display: flex;
      padding-left: 58px;
      box-sizing: border-box;
      .fast-link {
        margin-right: 120px;
        &:last-child {
          margin-right: 0;
        }
        ul {
          display: flex;
          flex-direction: column;
          list-style: none;
          .link-home{
            margin-bottom: 24px;
            font-size: 18px;
            font-weight: 500;
            color: #fff;
            line-height: 25px;
            &:hover {
              text-decoration: none;
            }
          }
          li {
            font-size: 16px;
            color: rgba(255, 255, 255, .65);
            line-height: 22px;
            margin-bottom: 12px;
          }
        }
      }
    }
    .link{
      width: @body-width;
      margin: 0 auto;
      .headline{
        display: inline-block;
        font-size:14px;
        color: #333333;
        line-height: 24px;
        margin-right: 30px;
        float: left;
      }
      .name {
        vertical-align:top;
        display: inline-block;
        span {
          a {
            margin: 0 30px 10px 0;
            font-size: 12px;
            color: #666666;
            line-height: 24px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/home/footer.vue